import React from "react";
import HomenetForm, { homenetDefaults } from "./services/HomenetForm";
import VincueForm, { vincueDefaults } from "./services/VincueForm";
import ReynoldsForm, { reynoldsDefaults } from "./services/ReynoldsForm";
import DealersCircleForm, { dealersCircleDefaults } from "./services/DealersCircleForm";
import OctaneForm, { octaneDefaults } from "./services/OctaneForm";
import AuctionEdgeForm, { auctionEdgeDefaults } from "./services/AuctionEdgeForm";
import MasheryForm, { masheryDefaults } from "./services/MasheryForm";
import CRSForm, { crsDefaults } from "./services/CRSForm";
import MastercraftForm, { mastercraftDefaults } from "./services/MastercraftForm";

export interface SyndicatorFormProps {
  config: any;
  onChange: (field: string, value: any) => void;
}

export interface SyndicatorEntry {
  Component: React.ComponentType<SyndicatorFormProps>;
  defaults: Record<string, any>;
}

export const SYNDICATOR_REGISTRY: Record<string, SyndicatorEntry> = {
  auctionEdge: { Component: AuctionEdgeForm, defaults: auctionEdgeDefaults },
  crs: { Component: CRSForm, defaults: crsDefaults },
  dealersCircle: { Component: DealersCircleForm, defaults: dealersCircleDefaults },
  homenet: { Component: HomenetForm, defaults: homenetDefaults },
  mashery: { Component: MasheryForm, defaults: masheryDefaults },
  mastercraft: { Component: MastercraftForm, defaults: mastercraftDefaults },
  octane: { Component: OctaneForm, defaults: octaneDefaults },
  reynolds: { Component: ReynoldsForm, defaults: reynoldsDefaults },
  vincue: { Component: VincueForm, defaults: vincueDefaults },
};
